//
// Replace any
// <span data-add-tax-and-commission='["Commission_Tier_1"]'>9.99</span>
// prices with the discounted price
// "-£9.99- 8.50 ex. vat"
//
// Factoring in their practitioner's 'customer discount' rate, if they're a client, and the product's commission tier
//
//
// Update: Not currently using anything involving practitioner/client status
//         or indeed anything to do with commission tiers
//         but it is all working and ready for the future/past
//
//
import {
  addTax,
  getCustomerTags,
  getCustomerIsTaxExempt,
} from "../../../common/dist/tax-and-commission";
import { getCurrencySymbol, currencyParse } from "../../../common/dist/utils";
//
// These tiers must be the same in 4 places! ***
// Including a checkout ruby script, the API .env file, _global-variables.liquid and commission-prices.es6 (here)
// const commissionTiers = [
//   // (not case sensitive)
//   { tag: "commission_exempt", rate: 0 },
//   { tag: "commission_tier_0", rate: 0.2 }, // <- when product has no tag!*
//   { tag: "commission_tier_1", rate: 0.25 }, // (no other tiers yet)
// ];
// const commissionTiersTags = commissionTiers.map((t) => t.tag);
// let isPractitioner = false; // Not logged in
// if (customerTags) {
//   isPractitioner = customerTags.some((t) => t.toLowerCase() === "practitioner");
// }
// // Practitioners: Full discount of 1
// let customerDiscount = 1;
// // Clients: Figure out if they have a Customer_Discount_ tag and make use of that
// if (!isPractitioner) {
//   customerTags &&
//     customerTags.forEach((t) => {
//       t = t.trim().toLowerCase();
//       if (t.includes("customer_discount_")) {
//         customerDiscount = parseFloat(t.replace("customer_discount_", ""));
//       }
//     });
// }
const updatePrices = () => {
  let prices = document.querySelectorAll("[data-add-tax-and-commission]");
  if (prices) {
    // For each price on the page, if not already modified
    prices.forEach((p) => {
      if (!p.classList.contains("taxed-and-commissioned")) {
        // If the price has no number (sometimes it's just the text "From".. sigh), ignore it
        if (p.innerHTML.match(/\d+/g)) {
          // // Grab all the product's tags, passed through as JSON
          // const productTagsJson = p.getAttribute("data-add-tax-and-commission");
          // if (!productTagsJson) {
          //   console.log("Product has no tax and commission tag data provided");
          //   return;
          // }
          // // Sometimes a product can be mysteriously void of data
          // const productTags = JSON.parse(productTagsJson);
          // if (!productTags) {
          //   console.log("Product has no tax and commission tag data provided");
          //   return;
          // }
          // // Default to commission_tier_0
          // let tierTag = "commission_tier_0";
          // // If the product has a commission set, as a tag, use that for the commission rate
          // let tierTagSearch = productTags.filter((t) => {
          //   return commissionTiersTags.includes(t.trim().toLowerCase());
          // })[0];
          // if (tierTagSearch) {
          //   tierTag = tierTagSearch.toLowerCase(); // e.g. "commission_tier_1"
          // }
          // const commission = commissionTiers.find((t) => t.tag === tierTag);
          // data-taxable="false" can be passed as an extra parameter to stop taxation
          const productIsTaxExempt =
            p.getAttribute("data-tax-exempt") &&
            p.getAttribute("data-tax-exempt") == "true"
              ? true
              : false;
          // const customerTags = getCustomerTags();
          const customerIsTaxExempt = getCustomerIsTaxExempt();
          const taxExempt = customerIsTaxExempt || productIsTaxExempt;
          // /////////////////////////////////////////
          // ///////////  Debugging  /////////////////
          // console.log("productTags", productTags);
          // console.log("tierTagSearch", tierTagSearch);
          // console.log("tierTag", tierTag);
          // console.log("commission", commission);
          // console.log("productIsTaxExempt", productIsTaxExempt);
          // console.log("customerIsTaxExempt", customerIsTaxExempt);
          // /////////////////////////////////////////
          // /////////////////////////////////////////
          // Regex the pounds and pence, as it were, for whatever currency
          const currency = getCurrencySymbol(p.innerHTML);
          // NOTE: It must be in 9,999.99 format - i.e. change formatting
          // in store to {{amount}} in /admin/settings/general
          // const priceOriginal = p.innerHTML.match(/\d+(?:\.\d+)?/g);
          const priceOriginal = currencyParse(p.innerHTML);
          let priceFinal = addTax({ priceOriginal, taxExempt });
          // console.log(p.innerHTML, priceOriginal, priceFinal, currency);
          // Rounding - can't use toFixed as it rounds .5 down! (FFS)
          priceFinal = (Math.round(priceFinal * 100) / 100).toFixed(2);
          // Apply price to the DOM
          // Could replace only the numeric part - if we ever have multiple currencies:
          // p.innerHTML = p.innerHTML.replace(
          //   /\d+(?:\.\d+)?/g,
          //   `<span class="strike">${priceOriginal}</span class="strike">£${priceFinal}`
          // );
          // if (priceOriginal == priceFinal) {
          //   p.innerHTML = `£${priceFinal} ex. taxes`;
          // } else {
          //   p.innerHTML = `<span class="strike">£${priceOriginal}</span class="strike"> £${priceFinal} ex. taxes`;
          // }
          // Update - Now including tax and no longer having a struck out original as it's a little confusing;
          // especially as the final price might be different (we're only adding tax, not commission discount)
          p.innerHTML = `${currency}${priceFinal}`;
          p.classList.add("taxed-and-commissioned");
        }
      }
    });
  }
};
// Initial calculation on page load
updatePrices();
const priceSubscriber = (mutations) => {
  mutations.forEach((mutation) => {
    updatePrices();
  });
};
// Obsolete as we're not using the old search plugin (but might need for some other reason)
// // If we're on a filtered products page, the listings are generated by JS (sigh)
// // So, watch for mutations like when people check boxes and update the prices
// const priceObserver = new MutationObserver(priceSubscriber);
// const filteredProducts = document.getElementById("bc-sf-filter-products");
// if (filteredProducts) {
//   priceObserver.observe(filteredProducts, {
//     childList: true,
//     // subtree: true // might need this, for mad changes
//   });
// }
